import { useContext } from "react";
import ObjectInputContext from "../contexts/objectInputContext";

const useObjectInput = () => useContext(ObjectInputContext);

export default useObjectInput;
